import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { APP_CONFIG } from './core/config/app-config.token';
import { AUTH_PORT } from './core/auth/auth-port';
import { AppShellComponent } from './shared/layout/app-shell.component';

type ErrorInicioSesion = 'auth' | 'sin_perfil';

function leerYLimpiarErrorInicioSesion(view: (Window & typeof globalThis) | null): ErrorInicioSesion | null {
  if (!view) {
    return null;
  }

  const valor = view.location.search ? new URLSearchParams(view.location.search).get('error') : null;
  if (valor !== 'auth' && valor !== 'sin_perfil') {
    return null;
  }

  const url = new URL(view.location.href);
  url.searchParams.delete('error');
  view.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
  return valor;
}

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppShellComponent],
  template: `
    @if (errorConfiguracion) {
      <div class="config-error" role="alert" data-testid="config-error">
        <h1>No se puede iniciar la consola</h1>
        <p>{{ errorConfiguracion }}</p>
      </div>
    } @else if (errorInicioSesion === 'auth') {
      <div class="config-error" role="alert" data-testid="error-inicio-sesion">
        <h1>No pudimos iniciar tu sesión</h1>
        <p>Intenta de nuevo.</p>
        <button type="button" data-testid="reintentar-inicio-sesion" (click)="reintentarInicioSesion()">Intentar de nuevo</button>
      </div>
    } @else if (errorInicioSesion === 'sin_perfil') {
      <div class="config-error" role="alert" data-testid="error-inicio-sesion">
        <h1>Tu usuario no tiene un perfil asignado en el Gestor</h1>
        <p>Pide acceso a tu jefatura.</p>
      </div>
    } @else {
      <app-shell />
    }
  `,
  styles: [
    `
      .config-error {
        display: grid;
        gap: 1rem;
        max-width: 40rem;
        margin: 4rem auto;
        padding: 2rem;
        text-align: center;
      }
    `,
  ],
})
export class AppComponent {
  private readonly config = inject(APP_CONFIG);
  private readonly authPort = inject(AUTH_PORT, { optional: true });

  // FE-85: VITE_AUTH_MODE inválido (modo simulada en prod, o modo entra sin configurar — FE-86: ya no aplica a entra).
  readonly errorConfiguracion: string | null =
    this.config.auth.modo === 'error'
      ? this.config.auth.errorConfiguracion ?? 'Configuración de autenticación inválida.'
      : null;

  // FE-86: ?error=auth o ?error=sin_perfil, puestos por el callback de /api/v1/auth/callback (enmienda E-7, CA-26).
  readonly errorInicioSesion: ErrorInicioSesion | null = leerYLimpiarErrorInicioSesion(inject(DOCUMENT).defaultView);

  protected reintentarInicioSesion(): void {
    this.authPort?.iniciar();
  }
}
